import { FormattedMessage } from "react-intl";
import { messages } from "./messages";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useIntercom } from "react-use-intercom";

export const AppBridgeTosPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { update } = useIntercom();

  useEffect(() => {
    const signed_agreement_id = searchParams.get("signed_agreement_id");

    if (signed_agreement_id) {
      window.parent.postMessage({ signed_agreement_id }, "*");
    }
  }, [searchParams]);

  useEffect(() => {
    update({ hideDefaultLauncher: true });
  }, [update]);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center p-8">
      <h1 className="mb-8 w-full text-center font-['Source_Sans_Pro'] text-2xl font-bold text-[--milkylb-color-secondary-600]">
        <FormattedMessage {...messages.title} values={{ br: <br /> }} />
      </h1>
    </div>
  );
};
